import { gql } from '@apollo/client'

export const DELETE = gql`
  mutation user_delete($id: ID!) {
    userDelete(id: $id) {
      id
    }
  }
`
